import { ChannelCodeType } from "@global-enum/ChannelCodeType";

export class UserForgetPasswordRequestModel {
  Email: string;
  EmailCode: string;
  PasswordHashNew: string;
  PasswordHashNewAgain: string;
  ChannelCode = ChannelCodeType.UI
}
